<div>
  <div
    *ngIf="pathBreadcrumbs.length"
    style="width: 80%; margin: auto; padding-top: 10px"
  >
    @for (
      breadcrumb of pathBreadcrumbs;
      track breadcrumb.path;
      let last = $last
    ) {
      <a
        [routerLink]="breadcrumb.path"
        [style.color]="env['colors']['primary']"
        [style.textDecoration]="'none'"
        >{{ breadcrumb.text }}
      </a>
      <span>{{ !last ? ' > ' : '' }}</span>
    }
  </div>
  <div class="tool-header-content" [style.marginTop]="marginTop">
    <h1
      class="tool-header-title"
      [style.color]="env['colors']['tool_btn_active']"
    >
      {{ headerTitle }}
      <mat-icon
        *ngIf="helpPagePath"
        style="color: black; cursor: pointer"
        matTooltip="Help"
        (click)="this.routeService.navigateNewTab(this.helpPagePath)"
        >help</mat-icon
      >
    </h1>
    <div class="tool-header-subtitle">{{ subtitle }}</div>
    <div class="tool-btn-group">
      <ng-container *ngFor="let item of toolTabItems">
        <button
          [ngStyle]="{
            'background-color': item.isActive
              ? env['colors']['tool_btn_active']
              : env['colors']['tool_btn_inactive'],
          }"
          [routerLink]="item.link"
          *ngIf="item.shouldShow"
          routerLinkActive="active"
          mat-flat-button
        >
          {{ item.text }}
        </button>
      </ng-container>

      <progress-bar *ngIf="dataPending"></progress-bar>
    </div>

    <mat-divider></mat-divider>
  </div>
</div>
